import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/renters/fr/en';
import { RentersPageTemplate } from '@/pageTemplate/RentersPageTemplate';
import { useEffect } from 'react';

export default function RentersPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();
  useEffect(
    () =>
      trackEventWithGeolocation('renters_page.viewed', {
        variant: 'default',
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return <RentersPageTemplate config={config} />;
}
